exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "jqxTree div {\n  border: none !important; }\n\n.jqx-item {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5; }\n\nli.navitem {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: 10px;\n  margin-right: 15px; }\n\nul.has-border {\n  border-bottom: 1px solid #dcd9d9;\n  padding-bottom: 1px; }\n\n/*body {\r\n  position: relative;\r\n}*/\n\n.dropDownButton.jqx-dropdownbutton-popup:first-of-type {\n  left: 10px !important;\n  top: 91px !important;\n  position: fixed !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/share/cay-thu-muc/caythumuc.component.scss
// module id = ../../../../../src/app/share/cay-thu-muc/caythumuc.component.scss
// module chunks = main